import { render, staticRenderFns } from "./RingSizeParams.vue?vue&type=template&id=25a3a366&scoped=true"
import script from "./RingSizeParams.vue?vue&type=script&lang=ts"
export * from "./RingSizeParams.vue?vue&type=script&lang=ts"
import style0 from "./RingSizeParams.vue?vue&type=style&index=0&id=25a3a366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a3a366",
  null
  
)

export default component.exports